import { customersActions } from "./customers-slice";
import { licensesActions } from "./licenses-slice";
import { hardwaresActions } from "./hardware-slice";
import { fetchRequest } from "../services/api";
import {
  getCustomerByIdRequest,
  getUpdateRequest,
  getRequestGetCustomers,
  getPostCustomerRequest,
  getRequestDeleteCustomer,
  getRegisterCustomerRequest
} from "../services/customres-requests";

import { uiActions } from "./ui-slice";
import { hardwareActions } from "./hardware-slice";

export const fetchCustomers = () => {
  return async (dispatch) => {
    dispatch(uiActions.setCustomersLoading(true));
    try {
      const customers = await fetchRequest(getRequestGetCustomers());
      dispatch(customersActions.set(customers));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    } finally {
      dispatch(uiActions.setCustomersLoading(false));
    }
  };
};

export const fetchCustomerById = (id) => {
  return async (dispatch) => {
    try {
      const customer = await fetchRequest(getCustomerByIdRequest(id));
      dispatch(customersActions.setCustomer(customer));
      if (!customer) {
        dispatch(licensesActions.set([]));
        dispatch(hardwaresActions.set([]));
      } else {
        dispatch(licensesActions.set(customer.licenses));
        dispatch(hardwaresActions.set(customer.hardwares));
      }
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const updateCustomer = (customer) => {
  return async (dispatch) => {
    try {
      const updatedCustomer = await fetchRequest(getUpdateRequest(customer));
      dispatch(customersActions.setName(updatedCustomer.name));
      dispatch(customersActions.setCompany(updatedCustomer.company));
      dispatch(
        uiActions.enqueNotification({
          message: "Saved",
          variant: "success",
        })
      );
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const addCustomer = (customer) => {
  return async (dispatch) => {
    try {
      const savedCustomer = await fetchRequest(
        getPostCustomerRequest(customer)
      );
      dispatch(customersActions.add(savedCustomer));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const delCustomer = (id) => {
  return async (dispatch) => {
    try {
      await fetchRequest(getRequestDeleteCustomer(id));
      dispatch(customersActions.del(id));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const registerCustomer = (customer) => {
  return async (dispatch) => {
    try {
      await fetchRequest(
        getRegisterCustomerRequest(customer), false
      );
      dispatch(uiActions.enqueNotification({
        message: "To complete the process please check your email for a validation request. Within the email you will find a link which you must click in order to activate your account.",
        variant: "info",
      }));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

